module.exports = "/assets/js/54d5af95792519838c36a326f1d9c05e.svg";